import EventCard from './eventCard';
let events_json = require('../seeders/seedEvents.json');

// function getCardInfo(){
//     const PORT=3000
//     const MONGO_URI="mongodb://localhost:27017/meetings"
//  }
function handleNewEvent(){
   // window.location.href= '/create-Meeting'
}



 function Events(props) {

   const username = props.user 
   const events = events_json
   console.log("Events: ", events)
   window.localStorage.setItem('cur_user',JSON.stringify(username))
   let header //= { header:'header'}
   let scroll_section //= {scroll_selection:'scroll_selection'}
   let inner_scroll_section =  document.getElementById(`meetings-header`)
   let elem_rect
   let offset
   let body_rect 
   //  document.addEventListener("DOMContentLoaded",getTag("header","meetings-header-wrap"))
    function getTag(sect_lbl,tag){
       console.log('getTag [shrugs]')
      if(sect_lbl === "header"){
         header =  document.getElementById(`${tag}`)
         console.log("header selected")
      }else if(sect_lbl === "scroll_section"){
         scroll_section =  document.getElementById(`${tag}`)
            // console.log("scrolling:",rect.top)
      } 
    
    
         
      // let sect_toup =(sect_lbl,sect)
        
      //  sect =  document.querySelector(`${tag}`)
      //  scroll_section =  document.getElementById('meeting-content-wrap')
      //  header =  document.getElementById('meetings-header-wrap')
      //  header =  document.getElementById('header')
      console.log(`getTags ${tag} for:`, sect_lbl)
      // console.log(`getTags sect_toup:`, sect_toup)
      // console.log("getTags scroll_section:",scroll_section)
       return sect_lbl
      }; 

  function initTags(){
         getTag("scroll_section","meeting-content-wrap")
         getTag("inner_scroll_section ","meeting-content")
         getTag("header","meetings-header-wrap")
         if(scroll_section){
            let scroll = false
            let orig_pos 
           
            scroll_section.addEventListener('scroll', (event) => {
               scroll = true
               console.log("scrolling:",scroll_section) 
               console.log("scrolling:",event.offsetY) 
               
               // if(scroll_section && header && inner_scroll_section){
               if(scroll){
                  header.classList='meetings-header-wrap show-header-shadow'
                  // elem_rect = scroll_section.getBoundingClientRect()
                  // orig_pos = elem_rect.top
                  // if(inner_scroll_section){
                  // scroll_section.addEventListener('scroll')
                     // body_rect = inner_scroll_section.getBoundingClientRect()

                     // offset = elem_rect.top - orig_pos
                     // if(elem_rect){
                     //    console.log("elem_rect.top: ",elem_rect)
                     // }
                     console.log("all three")
                     // console.log("offset: ",offset)
                     // console.log("header.classList: ",header.classList)
                     // if (offset)
                     
                     // else{header.classList='meetings-header-wrap'}
                  // }
               }
            })
            if (!scroll){
               header.classList = 'meetings-header-wrap'
            }else{header.classList='meetings-header-wrap show-header-shadow'}
         }
      }
   document.addEventListener("DOMContentLoaded",initTags())
   
   // if(document.addEventListener("DOMContentLoaded",getTags(scroll_section,"meeting-content-wrap"))){ 
   //    scroll_section.addEventListener('scroll', (event) => {
   //    console.log("scrolling")
   //    // if(!header){
   //    //    getTags()
   //    //    console.log("should be toggling 🤔")
         
   //    // }else{header.classList.toggle('show-header-shadow')}
   // })
   //    }//else{getTags()}
   // if(scroll_section){ 
   //    scroll_section.addEventListener('scroll', (event) => {
   //    console.log("scrolling")
      // if(!header){
      //    getTags()
      //    console.log("should be toggling 🤔")
         
      // }else{header.classList.toggle('show-header-shadow')}
   // })
      //else{getTags()}


   function generateEvents(){
       let event_map = events.map((event,index) => {
          return (<EventCard 
                    event={event} 
                    key={index} 
                    value={event?.event_id} 
                    view={props?.view}  
                    setView={props?.setView}/>)
       })
       return event_map   
    }
    
    return (
        <div className="meetings-container">  
            {/* <h1 className="view-header blink-slower">{props.view}</h1> */}
            {/* <div className='hub-content-wrap'>
                <div className='hub-button-wrap'>

                    <button
                        id="leave-btn"
                        className="hub-button"
                        onClick={() =>window.location.href = `/event`}
                        >
                        test event
                    </button>
                </div>
            </div> */}
        <div className="meetings-header-wrap" id="meetings-header-wrap" >
            <div className="meetings-header" id="meetings-header" >
                  <span className='add-new-meeting blink' onClick={handleNewEvent}><span className='add-new-meeting-btn'>&nbsp;+&nbsp;</span> &nbsp;new event</span>
               <span className='blink-slowerer' id="user-tag">greetings:<span className='user-text'> {username}</span></span>
                  <h1 className="view-header blink-slower">{props.view}</h1>
                  
            </div>
         </div>
            <div id='meeting-content-wrap'>
               <div className='meeting-content' id="meeting-content">
                  &nbsp;
                  {generateEvents()}
                  &nbsp;

                  <br></br>
                  &nbsp;
               </div>
            </div>
        </div>
  );
}
export default Events; 